import React, { useEffect, useState } from 'react';
import { InputMask } from '@react-input/mask';
import api from '../../config/axios';
import Swal from 'sweetalert2';

import PessoaModal from './modals/Pessoa';
import AnamneseListaModal from './modals/AnamneseLista';
import ComissaoColaboradorModal from './modals/ComissaoColaborador';
import Paginacao from '../../components/utils/paginacao';

import '../../assets/styles/clientes.css';
import { FaPlus, FaEdit, FaFilter, FaClipboardList, FaPercentage } from 'react-icons/fa';

const Pessoas = () => {
  const [error, setError] = useState(null);

  const [pessoas, setPessoas] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroEmail, setFiltroEmail] = useState('');
  const [filtroCpf, setFiltroCpf] = useState('');
  const [filtroColaborador, setFiltroColaborador] = useState(false);
  const [filtroCliente, setFiltroCliente] = useState(false);
  const [filtroFornecedor, setFiltroFornecedor] = useState(false);

  const [selectedPessoa, setSelectedPessoa] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAnamneseModalOpen, setIsAnamneseModalOpen] = useState(false);
  const [isComissaoModalOpen, setIsComissaoModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchPessoas = async (currentPage) => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      const params = {
        page: currentPage,
        limit: limit,
        nome: filtroNome,
        email: filtroEmail,
        cpf: filtroCpf
      };

      if (filtroColaborador) {
        params.e_colaborador = true;
      }
      if (filtroCliente) {
        params.e_cliente = true;
      }
      if (filtroFornecedor) {
        params.e_fornecedor = true;
      }

      const response = await api.get('/pessoas', { params });

      setPessoas(response.data.pessoas || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
      Swal.close();
    } catch (err) {
      Swal.close();
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    }
  };

  useEffect(() => {
    fetchPessoas(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddPessoa = () => {
    setSelectedPessoa(null);
    setIsModalOpen(true);
  };

  const handleEditPessoa = (pessoa) => {
    setSelectedPessoa(pessoa);
    setIsModalOpen(true);
  };

  const handleAnamnesePessoa = (pessoa) => {
    setSelectedPessoa(pessoa);
    setIsAnamneseModalOpen(true);
  };

  const handleComissaoPessoa = (pessoa) => {
    setSelectedPessoa(pessoa);
    setIsComissaoModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchPessoas(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
    setFiltroEmail('');
    setFiltroCpf('');
    setFiltroColaborador(false);
    setFiltroCliente(false);
    setFiltroFornecedor(false);
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Pessoas</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddPessoa}>
                <FaPlus /> Adicionar Pessoa
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-2 col-12">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome da pessoa"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-2 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">E-mail</label>
              <input
                type="email"
                autoComplete="off"
                placeholder="Digite o e-mail"
                value={filtroEmail}
                className="form-control"
                onChange={(e) => setFiltroEmail(e.target.value)}
              />
            </div>
            <div className="col-lg-2 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">CPF</label>
              <InputMask
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                className="form-control"
                autoComplete="off"
                placeholder="000.000.000-00"
                value={filtroCpf}
                onChange={(e) => setFiltroCpf(e.target.value)}
              />
            </div>
            <div className="col-lg-4 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">Tipo de Pessoa</label>
              <div className="d-flex flex-wrap gap-3 mt-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="filtroCliente"
                    checked={filtroCliente}
                    onChange={(e) => setFiltroCliente(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="filtroCliente">
                    Cliente
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="filtroColaborador"
                    checked={filtroColaborador}
                    onChange={(e) => setFiltroColaborador(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="filtroColaborador">
                    Colaborador
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="filtroFornecedor"
                    checked={filtroFornecedor}
                    onChange={(e) => setFiltroFornecedor(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="filtroFornecedor">
                    Fornecedor
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Nome</th>
                    <th>Celular</th>
                    <th>E-mail</th>
                    <th>CPF</th>
                    <th className="text-center">Data de Nascimento</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pessoas.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhuma pessoa encontrada.
                      </td>
                    </tr>
                  ) : (
                    pessoas.map((pessoa) => (
                      <tr key={pessoa.id}>
                        <td className="text-nowrap">{pessoa.nome}</td>
                        <td className="text-nowrap">{pessoa.celular}</td>
                        <td>{pessoa.email}</td>
                        <td className="text-nowrap">{pessoa.cpf}</td>
                        <td className="text-nowrap text-center">
                          {pessoa.data_nascimento ? pessoa.data_nascimento.split('-').reverse().join('/') : '-'}
                        </td>
                        <td className="text-nowrap text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditPessoa(pessoa)}
                            title="Editar pessoa"
                          >
                            <FaEdit />
                          </button>
                          {pessoa.e_cliente && (
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleAnamnesePessoa(pessoa)}
                              title="Visualizar anamnese"
                            >
                              <FaClipboardList />
                            </button>
                          )}
                          {pessoa.e_colaborador && (
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleComissaoPessoa(pessoa)}
                              title="Configurar comissões"
                            >
                              <FaPercentage /> 
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>

        </div>

        {isModalOpen && (
          <PessoaModal
            pessoa={selectedPessoa}
            onClose={() => setIsModalOpen(false)}
            onPessoaAtualizada={() => fetchPessoas(currentPage)}
          />
        )}

        {isAnamneseModalOpen && (
          <AnamneseListaModal
            pessoa={selectedPessoa}
            onClose={() => setIsAnamneseModalOpen(false)}
          />
        )}

        {isComissaoModalOpen && (
          <ComissaoColaboradorModal
            colaborador={selectedPessoa}
            onClose={() => setIsComissaoModalOpen(false)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Pessoas; 